import {clipOverlapsAny} from '~/utils/video-editor/clip-utils.js';

export function useVideoEditorStoreMarkers({clips, refreshMarkerSnapshot}) {

  function adjustMarker({marker, time, maxTime = Infinity, refreshSnapshot = true}) {
    let nextTime = typeof time === 'number' ? time : marker.time;

    nextTime = Math.max(nextTime, 0);
    if (Number.isFinite(maxTime)) {
      nextTime = Math.min(nextTime, maxTime);
    }

    const ownerClip = clips.value.find(clip => clip?.markers?.some(m => m === marker || m.id === marker.id));

    if (!ownerClip) {
      return false;
    }

    const markerIndex = ownerClip.markers.findIndex(m => m === marker || m.id === marker.id);

    if (markerIndex === -1) {
      return false;
    }

    for (const otherMarker of ownerClip.markers) {
      if (otherMarker === marker || otherMarker.id === marker.id) {
        continue;
      }
      if (nextTime <= otherMarker.time) {
        nextTime = Math.min(nextTime, otherMarker.time - VIDEO_EDITOR_MIN_CLIP_DURATION_SECONDS);
      } else {
        nextTime = Math.max(nextTime, otherMarker.time + VIDEO_EDITOR_MIN_CLIP_DURATION_SECONDS);
      }
    }

    if (nextTime < 0 || (Number.isFinite(maxTime) && nextTime > maxTime)) {
      return false;
    }

    const nextMarkers = ownerClip.markers.slice();
    nextMarkers[markerIndex] = {
      ...nextMarkers[markerIndex],
      time: nextTime
    };

    if (clipOverlapsAny({
      clip: {...ownerClip, markers: nextMarkers},
      clips: clips.value,
      excludeClipId: ownerClip.id ?? null,
      excludeClip: ownerClip
    })) {
      return false;
    }

    marker.time = nextTime;
    if (refreshSnapshot) {
      void refreshMarkerSnapshot({
        marker,
        time: nextTime
      });
    }

    return true;
  }

  return {
    adjustMarker
  };
}
